import { Component, inject } from '@angular/core';

import { NotificationService } from '../../../application/services/notification.service';
import { NotificationType } from '../../../domain/constants/notification.constants';
import { BannerComponent } from '../../components/banner/banner.component';
import { ToastComponent } from '../../components/toast/toast.component';

@Component({
    selector: 'notification-layout',
    templateUrl: './notification-layout.component.html',
    standalone: true,
    imports: [
        ToastComponent,
        BannerComponent,
    ],
})

export class NotificationLayoutComponent {
    private readonly notificationService = inject(NotificationService);

    public readonly type$$ = this.notificationService.type;

    protected readonly NotificationTypeEnum = NotificationType;
}
